export default __webpack_public_path__ + "static/media/Schaf.7409387e.png";